export class EventPhotoRemove {
	public photo: any;

	public status;
	public errorMessage;
	public queueNumber;
	public setToPrivate;
}